import React, { useContext } from "react";

import OfferHistoryButton from "@features/offer/desktop/buttons/OfferHistoryButton";
import { OfferOptionsContext, OfferStoreContext } from "@gp/components";
import { EventKeyBettingOffer } from "@gp/models";
import { useRootAppStore } from "@hooks/useRootAppStore";
import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";
import classNames from "classnames";
import { observer } from "mobx-react";

import OfferTipButton from "./OfferTipButton";

export const OfferTip = observer(function OfferTip(props: TOfferTipProps) {
	const offerStore = useContext(OfferStoreContext);
	const rootStore = useRootAppStore();
	const isBetBuilderTab = useContext(BetBuilderModeContext);
	const offerOptionContext = useContext(OfferOptionsContext);
	const {
		betBuilderStore: { nextOddsOff },
		betSlipStore: {
			betSlipState: { isMultiOfferEventPresent, isMultiOfferSelected },
		},
	} = rootStore;

	const marginClasses = classNames("quote quote--margin", {
		"quote--margin--long":
			props.isMargin && (props.margin?.length || 0) > 8,
		"quote--margin--res": props.isResult && (props.result?.length || 0) > 8,
	});

	if (props.isMargin) {
		return (
			<div className={props.className}>
				<div className={marginClasses}>{props.margin}</div>
			</div>
		);
	}

	if (props.isResult) {
		return (
			<div className={props.className}>
				<div className={marginClasses}>{props.result}</div>
			</div>
		);
	}
	// @ts-expect-error
	const isThisHistoryEvent = offerOptionContext.isHistoryEvent?.(props.tip?.eventId) ?? false;
	if (isThisHistoryEvent) {
		return (
			<div className={props.className}>
				<OfferHistoryButton
					label={props?.tip?.displayTip}
					hasMargin={props.tipLabelHasMargin}
					{...props}
				/>
			</div>
		);
	}
	/* IF YOU CHANGE THIS LINE YOU NEED TO ADD IF CHECK ON ONCLICK ON OFFERTIPBUTTON */
	if (props.tip == undefined || !props.tip.value) {
		if (props.isGroupedOfferTip) {
			return (
				<div className="offer--additional__inline__item is-empty">
					<div className="quote quote--placeholder" />
				</div>
			);
		}

		return <div className="quote quote--placeholder" />;
	}

	const event = offerStore.eventsMap.get(props.tip.eventId);
	const eventKeys = offerStore.eventKeysMap.get(props.tip.eventId);
	const key = eventKeys?.get(props.tip.keyId);
	const isSelected =
		isBetBuilderTab && !rootStore.betSlipStore.isOneClickBetActive
			? rootStore.betSlipStore.betSlipState.isMultiOfferSelected(
					event?.id,
					props.tip.id
				)
			: rootStore.betSlipStore.isTipSelected(props.tip.id);

	let isBetBuilderTipHidden = false;
	let isBetBuilderTipSelected = false;
	let betBuilderAvailableTip = null;
	//@ts-expect-error
	if (offerStore.betBuilderAvailableTips) {
		//@ts-expect-error
		betBuilderAvailableTip = offerStore.betBuilderAvailableTips.get(
			props.tip.id
		);

		if (isBetBuilderTab) {
			//@ts-expect-error
			if (isMultiOfferEventPresent(offerStore.event.id)) {
				if (isMultiOfferSelected(props.tip.eventId, props.tip.id)) {
					isBetBuilderTipSelected = true;
				} else if (!nextOddsOff) {
					if (betBuilderAvailableTip) {
						isBetBuilderTipHidden = false;
					} else {
						isBetBuilderTipHidden = true;
					}
				}
			} else {
				isBetBuilderTipHidden = false;
			}
		}
	}

	const tipValue =
		isBetBuilderTab && betBuilderAvailableTip && !nextOddsOff
			? betBuilderAvailableTip.providerValue
			: props.tip.value;

	return (
		<div className={props.className}>
			<OfferTipButton
				hasMargin={props.tipLabelHasMargin}
				value={tipValue}
				label={props.tip.displayTip}
				indicator={props.tip.indicator}
				displayTipName={props.displayTipName}
				isLocked={
					isSelected
						? false
						: event?.isLocked || key?.isLocked || props.tip.isLocked
				}
				onClick={() => {
					if (
						rootStore.waitingPeriodStore.timeLeft > 0 &&
						rootStore.betSlipStore.isOneClickBetActive
					) {
						rootStore.waitingPeriodStore.activatePopup();
						return;
					}

					if (
						!rootStore.betSlipStore.isOneClickBetActive &&
						isBetBuilderTab &&
						props.tip != null
					) {
						rootStore.betBuilderStore.updateQuotaAndSetAvailableOffers(
							props.tip,
							event
						);
					} else {
						rootStore.betSlipStore.addRemoveOffer({
							...props.tip,
							eventResultData: event?.result,
							matchTime: event?.matchTime,
						});
					}
				}}
				isSelected={isSelected}
				isOneClickBetActive={rootStore.betSlipStore.isOneClickBetActive}
				isPlayerMarket={props.isPlayerMarket}
				isAdditionalOffer={props.isAdditionalOffer}
				isBetBuilderTipHidden={isBetBuilderTipHidden}
				isBetBuilderTipSelected={isBetBuilderTipSelected}
				nextOddsOff={nextOddsOff}
			/>
		</div>
	);
});

type TOfferTipProps = {
	className?: string;
} & (
	| {
			isMargin: true;
			margin?: string;

			isResult?: false;
			result?: never;
	  }
	| {
			isMargin?: false;
			margin?: never;

			isResult: true;
			result: string;
	  }
	| {
			isMargin?: false;
			margin?: never;

			isResult?: false;
			result?: never;

			tipLabelHasMargin?: boolean;
			tip?: EventKeyBettingOffer;
			displayTipName?: string;
			isGroupedOfferTip?: boolean;
			isPlayerMarket?: boolean;
			isAdditionalOffer?: boolean;
	  }
);
